import React from 'react'
import { Tooltip } from 'antd'
import titleCase from 'title-case'
import { IBadgeProps } from './interfaces'
import './status-badge.scss'
import {
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleFilled,
    ExclamationCircleOutlined,
    InfoCircleOutlined,
    LockFilled,
    MailFilled,
    PauseCircleOutlined,
} from '@ant-design/icons'

type StatusBadgeType = 'account' | 'domain' | 'billing' | 'user' | 'generic'

/*
    "expanded" view forces hidden tooltip
    and displays the status text to the right
    of the badge
 */
interface IProps extends IBadgeProps {
    type: StatusBadgeType
    status: string
    expanded?: boolean
}

export const StatusBadge: React.FC<IProps> = (props) => {
    const hideTooltip = props.hideTooltip || props.expanded

    const text = props.status
    let icon = <CheckCircleOutlined />

    if (props.status === 'DISABLED') {
        icon = <PauseCircleOutlined />
    }

    if (props.type === 'billing') {
        switch (props.status) {
            case 'OPEN':
                icon = <InfoCircleOutlined />
                break
            case 'PENDING':
                icon = <ClockCircleOutlined />
                break
            case 'UNCONFIRMED':
                icon = <ExclamationCircleOutlined />
                break
        }
    } else if (props.type === 'generic') {
        switch (props.status) {
            case 'EXPIRED':
                icon = <ExclamationCircleOutlined />
                break
        }
    } else if (props.type === 'user') {
        switch (props.status) {
            case 'INVITED':
                icon = <MailFilled />
                break
            case 'PASSWORD_RESET':
                icon = <LockFilled />
                break
            case 'DISABLED':
                icon = <CloseCircleFilled />
                break
        }
    }

    const badge = <span className={`status-icon status-${text}`}>{icon}</span>

    return (
        <span className={`status-badge ${props.type}-status-badge`}>
            {hideTooltip ? (
                !props.expanded ? (
                    badge
                ) : (
                    <>
                        {badge}
                        <span className="status-name">{titleCase(text)}</span>
                    </>
                )
            ) : (
                <Tooltip title={props.tooltip || text}>{badge}</Tooltip>
            )}
        </span>
    )
}
